import { MSG_ERRO_PADRAO } from "../services/api-integracao-openai.service";

export const handleErrorResponse = (
  err: any,
  setMsg: Function,
  handleError: Function,
  handleLogout: Function
) => {
  if (err.response) {
    const codigo = err.response.data?.codigo;
    if (err.response.status === 401 || codigo === "NAO_AUTORIZADO") {
      handleLogout();
      return;
    }
    const mensagem = err.response.data?.mensagem;
    setMsg(
      typeof mensagem === "string" && mensagem.trim()
        ? mensagem.trim()
        : MSG_ERRO_PADRAO
    );
    handleError();
  } else {
    setMsg(MSG_ERRO_PADRAO);
    handleError();
  }
};
